import * as React from 'react';

import { DashboardContent, dashboardContents } from '../../assets/contents/dashboard.content';
import { Locale } from '../enums/locale.enum';

interface LocaleProviderProps {
  children: React.ReactNode;
}

interface LocaleContextValue {
  locale: Locale;
  localizedContent: DashboardContent;
}

const DEFAULT_LOCALE: Locale = Locale.English;
const DEFAULT_LOCALIZED_CONTENT: DashboardContent = dashboardContents[DEFAULT_LOCALE];

const localeContextValue: LocaleContextValue = {
  locale: DEFAULT_LOCALE,
  localizedContent: DEFAULT_LOCALIZED_CONTENT,
};

const LocaleContext = React.createContext(localeContextValue);

export class LocaleProvider extends React.Component<LocaleProviderProps> {
  TIME_INTERVAL: number = 1000 * 20; // 20 seconds

  state = {
    locale: DEFAULT_LOCALE,
  };

  localeInterval: NodeJS.Timeout;

  componentDidMount() {
    this.localeInterval = setInterval(() => this.switchLocale(), this.TIME_INTERVAL);
  }

  componentWillUnmount() {
    if (this.localeInterval) {
      clearInterval(this.localeInterval);
    }
  }

  switchLocale = () => {
    const { locale } = this.state;

    this.setState({
      locale: locale === Locale.English ? Locale.Korean : Locale.English,
    });
  };

  render() {
    const { children } = this.props;
    const { locale } = this.state;

    const value: LocaleContextValue = {
      locale,
      localizedContent: dashboardContents[locale],
    };

    return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
  }
}

export const withLocale = (BaseComponent: React.ComponentClass<any>) => (props: any) => {
  return (
    <LocaleContext.Consumer>
      {({ locale, localizedContent }: LocaleContextValue) => (
        <BaseComponent {...props} locale={locale} localizedContent={localizedContent} />
      )}
    </LocaleContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/app/dashboard/contexts/locale.context.tsx